var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-list",
    { staticClass: "pa-1" },
    [
      _c("SoliStudent", {
        staticClass: "custom-btn",
        attrs: { student: _vm.form.student, disabled: "" },
      }),
      _vm._v(" "),
      _c("SoliTeacher", {
        staticClass: "custom-btn",
        attrs: { teacher: _vm.form.teacher, disabled: "", blueBorder: "" },
      }),
      _vm._v(" "),
      !_vm.$page.props.auth.user.virtual_client
        ? _c("SoliLocation", {
            staticClass: "custom-btn",
            attrs: {
              location: _vm.form.location,
              room: _vm.form.room,
              online: _vm.form.online,
              address: _vm.form.offSiteLocation?.address,
              disabled: "",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("ConfirmDateTime", {
        staticClass: "custom-btn",
        attrs: {
          date: _vm.form.startDate,
          time: _vm.form.startTime,
          repeating: _vm.getRepeating,
          disabled: "",
        },
      }),
      _vm._v(" "),
      _c("ConfirmLesson", {
        staticClass: "custom-btn",
        attrs: {
          type: _vm.form.type,
          instrument: _vm.form.instrument,
          duration: _vm.form.duration,
          assessmentType: _vm.form.assessmentType,
          event: _vm.form.templateEvent || _vm.form.credit?.group_event,
          substitutePass: _vm.form.substitutePass,
          disabled: "",
        },
      }),
      _vm._v(" "),
      _c("ConfirmBilling", {
        staticClass: "custom-btn",
        attrs: {
          billingUser: _vm.form.billingUser,
          purchaseOption: _vm.form.purchaseOption,
          disabled: "",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }